module.exports = __webpack_public_path__ + "static/img/benefit_mb2.7d44783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit_mb2.png
// module id = Q4uc
// module chunks = 30